const styles = {
    card: {
        width: "90vw",
        marginBottom: "20px"
    },
    gray: {
        color: "#4E6D6F"
    },
    doneCard: {
        backgroundColor: "#F0F4F2",
        boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.08), 0px 2px 24px rgba(0, 0, 0, 0.08)"
    },
    cardHeader: {
        display: "flex",
        paddingBottom: "4px",
        justifyContent: 'space-between'
    },
    cardHeaderItem: {
        display: "flex",
        padding: 0
    },
    cardFooterItem: {
        padding: 0,
        paddingLeft:"4vw"
    },
    icon: {
        marginRight: "2.13vw",
    },
    iconRight: {
        marginLeft: "2.13vw",
    },
    headerText: {
        fontSize: "12px",
        lineHeight: '18px',
        fontFamily: "IBM Plex Sans",
    },
    orange: {
        color: '#FF7C49'
    },
    doctorSpeciality: {
        fontSize: "16px",
        lineHeight: '24px',
        fontWeight: "500",
        fontFamily: "Roboto",
        fontStyle: "medium",
        color: "#000000",
        marginLeft: "16px",
        textTransform: 'capitalize'
    },
    doctorName: {
        color: "#424F49",
        fontFamily: "IBM Plex Sans",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "18px",
        marginLeft: "16px",
        maxWidth: "304px",
        paddingBottom: "13px"
    }
}

export default styles
